<img class=" grid_item" [src]="assetsImage" onerror="this.style.opacity='0'">